import { withTranslation } from "next-i18next";
import { Image, Button, CloseButton } from "@components/core";

function TourGuideTooltip({
  steps,
  continuous,
  index,
  step,
  closeProps,
  primaryProps,
  tooltipProps,
  t,
}) {
  return (
    <section
      {...tooltipProps}
      className="bg-white pt-4 mx-2 tour-guide-tooltip-container"
      id={`tour-guide-tooltip-step-${index + 1}`}
    >
      <p className="font-size-sm text-primary mb-0 tooltip-show-progress">
        {`${index + 1} / ${steps.length}`}
      </p>
      <CloseButton
        {...closeProps}
        title={`${t("common:close")} - step: ${step.title} - ${index + 1}/${steps.length}`}
        className="tooltip-close-button"
      >
        {null}
      </CloseButton>
      <div className="d-flex flex-column justify-content-center align-items-center text-center px-3">
        <Image
          src={step.imageSrc}
          alt={step.imageSrc}
          width={120}
          height={80}
        />
        <p className="font-weight-bold pt-3 mb-2">{step.title}</p>
        <p className="font-size-sm">{step.content}</p>
      </div>
      <div>
        {continuous && (
          <div className="d-flex flex-grow-1 bg-white border-top border-light">
            <Button
              {...primaryProps}
              title={`${step.buttonText} - step: ${step.title} - ${index + 1}/${steps.length}`}
              variant="ghost-primary"
              fullWidth
            >
              {step.buttonText}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}

export default withTranslation("common")(TourGuideTooltip);
